import { FC, useMemo } from "react"

// components
import Topic from "./Topic"

// styles
import {
  topicSection,
  topicSectionHeader,
  topicSectionButtons
} from "../BrowseByTopicSection/Topic.module.scss"

export type Props = {
  content:
    | Queries.HomepageDataQuery["helpCenterHomePage"]["attendee"]["content"][1]
    | Queries.HomepageDataQuery["helpCenterHomePage"]["organizer"]["content"][1]
  prefixedBasePath: string
}

const TopicSection: FC<Props> = ({ content, prefixedBasePath }) => {
  const topics = useMemo(() => {
    if ("attendeeCategories" in content) {
      return content?.attendeeCategories
    } else if ("organizerCategories" in content) {
      return content?.organizerCategories
    }
  }, [content])

  if ("attendeeCategories" in content || "organizerCategories" in content) {
    return (
      <div className={topicSection}>
        <h2 className={topicSectionHeader}>{content?.title}</h2>
        <div className={topicSectionButtons}>
          {topics.map((topic) => (
            <Topic
              key={topic.title}
              topic={topic}
              prefixedBasePath={prefixedBasePath}
            />
          ))}
        </div>
      </div>
    )
  }

  return null
}

export default TopicSection
